import { IMultiCheckbox, mvConverters } from "cayo.ui";

export function getValueConverter(a: IMultiCheckbox) {
  const type = a.type;
  if (a.type === "mv.checkbox" && a.formatter === "flags") {
    return {
      from: (v: any[]) => {
        return Array.isArray(v)
          ? v.filter((vv) => a.possibleValues?.find((pv) => pv.value === vv)).join(", ")
          : "";
      },
      to: (v: any) => {
        const result = typeof v === "string" ? (v as string).split(",").map((x) => x.trim()) : [];
        return result;
      },
    };
  }

  return {
    from: mvConverters.from[type],
    to: mvConverters.to[type],
  };
}
